<template>
	<div class="ts-h-1/3 ts-overflow-y-scroll">
		<h3 class="ts-text-xs ts-uppercase ts-text-blue-700">{{ $t('productProfile.branchList') }}</h3>
		<div class="ts-pl-8 ts-space-y-2">
      <a-select
        class="ts-w-full"
        mode="multiple"
        v-model="model.other_branch_list"
        :options="branchList"
        :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
        :maxTagCount="5"
      ></a-select>
		</div>
	</div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'branchList',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
	},
	computed:{
    branchList(){
      return this.$store.state.product.profile.branches.map(el => ({
        value: el.branch_id,
        label: el.branch_name_en
      }))
    }
	},
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>